import { useCallback, useId } from 'react';

// One scope per field family keeps sibling errors distinct across repeated forms.
export const useErrorIds = () => {
  const scope = useId();
  return useCallback(
    (field: string) => `field-error-${scope}-${field}`,
    [scope],
  );
};
